export enum ErrorStrings {
  GENERIC_ERROR_MESSAGE = 'The system encountered an error fulfilling your request. Please try again',
  GENERIC_SIGNIN_ERROR_MESSAGE = 'Invalid credentials',
  GENERIC_RESET_PASSWORD_MESSAGE = 'An email with a confirmation code has been sent to the given address',
  GRANT_UPLOAD_IN_PROGRESS = 'You have started the data upload process. However, unsaved changes could be lost if you choose to navigate away from this page. Are you sure you want to continue?',
  NO_GRANT_SELECTED = 'You must select a grant before navigating elsewhere on this site',
}
